/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/indent */
import { PriorAuthorizationDomainHead } from '../../interfaces/PriorAuthorizationDomain';
import './sidebar.component.css';

interface ISidebarProps {
    priorAuthDomainHeadObj?: PriorAuthorizationDomainHead
}

const ProSidebar = ({ priorAuthDomainHeadObj }: ISidebarProps) => {
    function formatDateString(dateString: string | undefined) {
       let localeDateString;
       if (dateString !== undefined) localeDateString = new Date(dateString).toLocaleDateString();

       return localeDateString;
    }

    return (
      <div className="form-group  mb-0 p-4" id="member-info">
        <div className="row mt-5">
          <div className="col d-flex flex-wrap justify-content-start align-items-baseline mb-1 member-name">{priorAuthDomainHeadObj?.memberFirstName} {priorAuthDomainHeadObj?.memberLastName}</div>
          <div className="col-auto d-flex flex-wrap">
            <p className="member-property-title">DOB:</p>
            <p className="mb-0 member-value" data-testid="memberDOB"> {formatDateString(priorAuthDomainHeadObj?.memberDOB)}</p><span className="ml-2 mr-2 align-items-baseline text-gray divider"><b> | </b></span>
            <p className="member-property-title">Member ID:</p>
            <p className="mb-0 member-value" data-testid="memberID">{priorAuthDomainHeadObj?.memberId}</p>
          </div>
        </div>
      </div>
    );
};

export default ProSidebar;
